module.exports = __webpack_public_path__ + "static/media/CROWN.9bae7c35.svg";